export function createSelectedFeatureManager(config) {
    var selectedFeatureCache = { parcel: {}, building: {} };
    var selectedFeatureRequest = null;

    function getFeatureKey(layerType, featureId) {
        if (!layerType || !featureId) return null;
        return layerType + ':' + String(featureId);
    }

    function abortCurrentRequest() {
        if (selectedFeatureRequest && selectedFeatureRequest.controller) {
            selectedFeatureRequest.controller.abort();
            selectedFeatureRequest = null;
        }
    }

    function ensureData(layerType, featureId, options) {
        options = options || {};

        var selectedFeatureId = config.getSelectedFeatureId(layerType);
        if (!featureId || String(featureId) !== String(selectedFeatureId)) {
            return;
        }

        var featureKey = getFeatureKey(layerType, featureId);
        var requestOptions = {
            renderLayer: options.renderLayer !== false,
            renderDetails: !!options.renderDetails
        };

        if (!selectedFeatureCache[layerType]) {
            selectedFeatureCache[layerType] = {};
        }

        var cacheBucket = selectedFeatureCache[layerType] || {};
        var cachedData = cacheBucket[String(featureId)] || null;
        if (cachedData) {
            if (requestOptions.renderLayer && config.getRenderedLayerKey() !== featureKey) {
                config.renderLayer(cachedData, layerType, featureKey);
            }
            if (requestOptions.renderDetails) {
                config.renderDetails(layerType, cachedData);
            }
            return;
        }

        if (selectedFeatureRequest && selectedFeatureRequest.key === featureKey) {
            selectedFeatureRequest.renderLayer = selectedFeatureRequest.renderLayer || requestOptions.renderLayer;
            selectedFeatureRequest.renderDetails = selectedFeatureRequest.renderDetails || requestOptions.renderDetails;
            return;
        }

        abortCurrentRequest();

        var controller = new AbortController();
        var perfToken = config.perfStart('selected-feature-fetch', {
            featureId: String(featureId),
            layerType: layerType,
        });
        var requestState = {
            key: featureKey,
            controller: controller,
            renderLayer: requestOptions.renderLayer,
            renderDetails: requestOptions.renderDetails
        };

        selectedFeatureRequest = requestState;

        fetch(config.getRequestUrl(layerType, featureId), { signal: controller.signal })
            .then(function(response) { return response.json(); })
            .then(function(data) {
                if (controller.signal.aborted) {
                    return;
                }
                if (String(featureId) !== String(config.getSelectedFeatureId(layerType))) {
                    return;
                }
                if (!data || !data.features || !data.features.length) {
                    if (requestState.renderDetails) {
                        config.renderError('Nie znaleziono obiektu');
                    }
                    return;
                }

                selectedFeatureCache[layerType][String(featureId)] = data;
                if (requestState.renderLayer) {
                    config.renderLayer(data, layerType, featureKey);
                }
                if (requestState.renderDetails) {
                    config.renderDetails(layerType, data);
                }
            })
            .catch(function(error) {
                if (error && error.name === 'AbortError') {
                    return;
                }
                if (requestState.renderDetails) {
                    config.renderError('B\u0142\u0105d \u0142adowania');
                }
            })
            .finally(function() {
                config.perfEnd(perfToken, {
                    activeSelection: getFeatureKey(layerType, config.getSelectedFeatureId(layerType)),
                    cached: false,
                });
                if (selectedFeatureRequest === requestState) {
                    selectedFeatureRequest = null;
                }
            });
    }

    return {
        abortCurrentRequest: abortCurrentRequest,
        ensureData: ensureData,
    };
}